module.exports = __webpack_public_path__ + "img/laptop-screen.6a2b8302.svg";